import React, { useState } from 'react';
import styled from "styled-components"
import { Carousel } from "../carousel/carousel"

const Wrapper = styled.div`
 height: 100%;
`

const Gallery = ({ content, bgData, imageSize }) => {

    const [[page, direction], setPage] = useState([0, 0]);

    const paginate = (newDirection) => {
        setPage([page + newDirection, newDirection]);
    };

    return (

        <Wrapper>
            <Carousel autoPlay={false} images={content} bgData={bgData} page={page} direction={direction} paginate={paginate} imageSize={imageSize} />
        </Wrapper>

    )
}

export default Gallery